/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AnyNonRedactedAutoTestStepAsJSON } from './AnyNonRedactedAutoTestStepAsJSON';
import { IOTestExtra } from './IOTestExtra';
const IOTestAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(IOTestExtra, AnyNonRedactedAutoTestStepAsJSON);
export class IOTestAsJSON extends AnyNonRedactedAutoTestStepAsJSON {
    static decode(input) {
        return IOTestAsJSONParser.decode(input).map(res => new IOTestAsJSON(res));
    }
    static unsafeDecode(input) {
        return IOTestAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestAsJSONParser.encode(data);
    }
    static schema() {
        return IOTestAsJSONParser.schema();
    }
}
